/*
  CRAN. — Parallax léger sur les macros métal (Partie 2, polish).
  Purement décoratif : décale le bloc image de quelques pixels au
  scroll, sans jamais changer sa taille ni son cadrage. Aucun état de
  repos ne dépend de ce script — sans lui, ou avec
  prefers-reduced-motion, l'image reste simplement immobile à sa
  position naturelle (transform: none, valeur par défaut du navigateur).
*/
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var items = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  if (!items.length) {
    return;
  }

  var MAX_OFFSET = 16; // px — jamais assez pour révéler un bord ou chevaucher la rangée voisine
  var ticking = false;

  function update() {
    var viewportHeight = window.innerHeight;
    items.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      var distanceFromCenter = center - viewportHeight / 2;
      var progress = Math.max(-1, Math.min(1, distanceFromCenter / viewportHeight));
      var offset = (progress * MAX_OFFSET * -1).toFixed(1);
      el.style.transform = 'translateY(' + offset + 'px)';
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
